import { graphql } from 'gatsby';
import React, { useEffect } from 'react';
import Img, { ImgProps } from 'components/img/img';
import './forschungDetail.scss';
import parse from 'html-react-parser';
import { TransLink } from 'components/trans/transLink';

interface Props {
  title: string;
  text: string;
  image: ImgProps;
  link: {
    target: string;
    title: string;
    url: string;
  };
}

const ForschungDetail: React.FC<Props> = (props) => {
  return (
    <div className="forschung" id={'a-' + props.title.toLowerCase().replace(' ', '-')}>
      <div className="forschung-wrapper">
        <div className="forschung__inner">
          <div className="forschung-image">
            <Img {...props.image} />
          </div>
          <div className="forschung-content">
            <p>{parse(props.text)}</p>
            {!!props.link && (
              <TransLink to={props.link.url} className="link-button">
                {props.link.title}
              </TransLink>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForschungDetail;

export const query = graphql`
  fragment ForschungDetailBlock on WpAcfForschungdetailBlock {
    ForschungDetail {
      title
      text
      image {
        ...BGImage
      }
      link {
        target
        title
        url
      }
    }
  }
`;
